import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Alert = props => {
  const [isOpen, setIsOpen] = useState(true);

  const alertClassName = classnames('alert', {
    'alert-success': props.isSuccess || false,
    'alert-error': props.isError || false,
    'alert-sm': props.isSmall || false,
  });

  const closeAlert = e => {
    e.preventDefault();
    setIsOpen(false);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className={alertClassName}>
      <p>{props.message}</p>
      {(props.isClosable || false) && (
        <a onClick={closeAlert}>
          <img src="img/icons/close.svg" className="is-block" />
        </a>
      )}
    </div>
  );
};

Alert.propTypes = {
  message: PropTypes.string.isRequired,
  isSuccess: PropTypes.bool,
  isError: PropTypes.bool,
  isSmall: PropTypes.bool,
  isClosable: PropTypes.bool,
};

export default Alert;
